import { useLoadRemoteUserSettings } from '~/components/UserSettings';
import { useLoadRemoteCompanyPreferences } from '~/data/companyPreferences/useLoadRemoteCompanyPreferences';

import {
  CompanyWorkspaceSettingsKey,
  MyWorkspaceUserSettingsKey,
} from './userSettings';

export interface UseMyWorkspaceOutput {
  isLoading: boolean;
  failedToLoad: boolean;
}

export const useMyWorkspace = (): UseMyWorkspaceOutput => {
  const {
    isLoading: isLoadingUserSettings,
    failedToLoad: failedToLoadUserSettings,
  } = useLoadRemoteUserSettings([MyWorkspaceUserSettingsKey]);

  const {
    isLoading: isLoadingCompanyPreferences,
    failedToLoad: failedToLoadCompanyPreferences,
  } = useLoadRemoteCompanyPreferences([CompanyWorkspaceSettingsKey]);

  return {
    isLoading: isLoadingUserSettings || isLoadingCompanyPreferences,
    failedToLoad: failedToLoadUserSettings || failedToLoadCompanyPreferences,
  };
};
